(function() {
  var __hasProp = {}.hasOwnProperty,
    __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

  define('app/models/Pipod',['backbone', 'moment', 'app/collections/NowPlayingCollection', 'app/models/Song'], function(Backbone, moment, NowPlayingCollection, Song) {
    'use strict';
    var Pipod;
    return Pipod = (function(_super) {
      __extends(Pipod, _super);

      function Pipod() {
        return Pipod.__super__.constructor.apply(this, arguments);
      }

      Pipod.prototype.parse = function(data) {
        if (data.last_seen) {
          data.last_seen = moment(data.last_seen);
        }
        if (data.playing_since) {
          data.playing_since = moment(data.playing_since);
        }
        this.nowPlaying || (this.nowPlaying = new Song());
        if (data.now_playing) {
          this.nowPlaying.set(this.nowPlaying.parse(data.now_playing));
        }
        return data;
      };

      Pipod.prototype.url = function() {
        return NowPlaying.api + '/pipods/' + this.get('mac_address');
      };

      Pipod.prototype.initialize = function() {
        this.nowPlayingList = new NowPlayingCollection;
        return this.nowPlayingList.url = this.url() + '/now_playing';
      };

      return Pipod;

    })(Backbone.Model);
  });

}).call(this);

//# sourceMappingURL=Pipod.js.map
;
